import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from '../Pagination'
import { updateStateJurnalSiswa } from '../../features/jurnalSiswaSlice'
import imgErrorValidation from '../../utils/imgErrorValidation'
import orangImage from '../../assets/images/user-foto.png'

let PageSize = 10;

function Table() {
    const dispatch = useDispatch()
    const {
        jurnalBelumDivalidasi,
        jurnalValid,
        jurnalTidakValid,
        keterangan,
        currentPage,
        loading,
    } = useSelector(state => state.jurnalSiswa)

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;

        let selectedData = [];
        if (keterangan === 'Belum Divalidasi') selectedData = jurnalBelumDivalidasi;
        else if (keterangan === 'Valid') selectedData = jurnalValid;
        else if (keterangan === 'Tidak Valid') selectedData = jurnalTidakValid;

        return selectedData.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, keterangan, jurnalBelumDivalidasi, jurnalValid, jurnalTidakValid])

    function statusColor(status) {
        if (status === 'Tidak Valid') return '#FF4530';
        if (status === 'Valid') return '#277FFE';
        return '#9B9B9B';
    }

    const totalCount =
        keterangan === 'Belum Divalidasi' ? jurnalBelumDivalidasi.length :
        keterangan === 'Valid' ? jurnalValid.length :
        jurnalTidakValid.length;

    return (
        <>
            <table className='table'>
                <thead>
                    <tr>
                        <th className='th-niy'>NIY</th>
                        <th className='th-name'>Nama Guru</th>
                        <th className='th-tipe'>Tipe</th>
                        <th className='th-mapel'>Mapel</th>
                        <th className='th-jabatan'>Tanggal</th>
                        <th className='th-jabatan'>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading
                        ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentTableData.length === 0
                            ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr>
                            : currentTableData.map((item, key) => (
                                <tr key={key}>
                                    <td className='niy-col'>{item?.niy}</td>

                                    <td className='row-img'>
                                        <img src={item?.user?.link_foto || orangImage} onError={imgErrorValidation} alt="" />
                                        {item?.nama}
                                    </td>
                                    <td>{item?.tipe_jurnal}</td>
                                    <td>{item?.mapel}</td>
                                    <td>{item?.tanggal_jurnal}</td>
                                    <td style={{ color: statusColor(item?.status) }}>{item?.status}</td>
                                </tr>
                            ))
                    }
                </tbody>
            </table>

            {!loading && (
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={totalCount}
                    pageSize={PageSize}
                    onPageChange={page => dispatch(updateStateJurnalSiswa({ name: 'currentPage', value: page }))}
                />
            )}
        </>
    )
}

export default Table
